import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from 'react';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import moment from 'moment/moment';
import NominaPrint from './NominaPrint';
import { AuthContext } from '../../auth/AuthContext';
import PrintFinYear from './PrintFinYear';
// Obtener la fecha actual
const today = moment();

// Determinar los valores de inicio y fin
let inicioe, fine;
if (today.date() <= 15) {
    inicioe = moment().startOf('month').format('YYYY-MM-DD'); // Primer día del mes actual
    fine = moment().date(15).format('YYYY-MM-DD'); // Día 15 del mes actual
} else {
    inicioe = moment().date(16).format('YYYY-MM-DD'); // Día 15 del mes actual
    fine = moment().endOf('month').format('YYYY-MM-DD'); // Último día del mes actual
}

const ModFinYear = ({ dia, show, onClose, user, finanio }) => {
    const { setResp } = useContextInfo();
    const id_emp = localStorage.getItem('idemployed');
    const { auth } = useContext(AuthContext);

    const [diasTomados, setDiasTomados] = useState(0);
    const [diasPagados, setDiasPagados] = useState(finanio.diasVacaciones);
    const [primaVacacional, setPrimaVacacional] = useState(finanio.primaVacacional);
    const [totalFinal, setTotalFinal] = useState(finanio.total);

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [start, setStart] = useState(inicioe);

    const [values, handleInputChange, reset, setFormValue] = useForm({
        inicio: inicioe,
        fin: fine,
        faltas: 0,
        extra: 0,
        transferencia: 0,
        efectivo: 0,
        tlqn: 0,
        total: 0,
        dvrest: diasTomados,
        dvtotal: finanio.diasVacaciones,
        tlvac: diasPagados,
        tlprima: primaVacacional,
        tlnaldo: finanio.aguinaldo,
    });
    const { extra, faltas, fin } = values;
    const { inicio_labores } = user;
    useEffect(() => {
        // Validar que los días tomados no sean mayores a los disponibles
        if (diasTomados > finanio.diasVacaciones) {
            console.warn('Los días tomados no pueden exceder los días disponibles.');
            setDiasTomados(finanio.diasVacaciones); // Ajusta automáticamente
            return;
        }

        // Calcular días restantes correctamente
        const diasRestantes = finanio.diasVacaciones - diasTomados;

        // Calcular prima vacacional (basado en días restantes)
        const primaCalculada = diasRestantes * dia * 0.25;

        // Recalcular total (suma de días pagados, prima y aguinaldo)
        const totalRecalculado = diasRestantes * dia + finanio.aguinaldo + primaCalculada;

        // Actualizar estados
        setDiasPagados(diasRestantes);
        setPrimaVacacional(primaCalculada);
        setTotalFinal(totalRecalculado);

        // Actualizar formulario
        setFormValue({
            ...values,

            dvrest: diasTomados, // Días restantes calculados correctamente
            dvtotal: finanio.diasVacaciones,
            tlvac: diasRestantes * dia, // Total días vacaciones pagados
            tlprima: primaCalculada, // Prima vacacional recalculada
            tlnaldo: finanio.aguinaldo, // Aguinaldo (constante en este cálculo)
        });
    }, [diasTomados, dia, finanio]);

    const funClose = () => {
        reset();
        onClose();
    };
    useEffect(() => {
        if (moment(start).isBefore(moment(inicio_labores))) {
            setStart(inicio_labores);
        }
    }, [inicio_labores]);

    useEffect(() => {
        let diasServicio = 0;

        const inicioLaboresMoment = moment(start, 'YYYY-MM-DD'); // Parseando la fecha correctamente
        const finLaboresMoment = moment(fin, 'YYYY-MM-DD'); // Parseando la fecha correctamente

        if (!inicioLaboresMoment.isValid()) {
            console.error('Fecha de inicio de labores no es válida');
        } else {
            diasServicio = moment(finLaboresMoment).diff(inicioLaboresMoment, 'days');
            diasServicio += 1;
        }
        let total = 0;
        if (diasServicio >= 15) {
            total = Math.round(dia * 15);
        } else {
            total = Math.round(dia * diasServicio);
        }
        if (extra > 0) {
            total += extra * dia * 2;
        }
        if (faltas > 0) {
            let totalFaltas = dia * 1.16 * faltas;
            total -= totalFaltas;
        }

        setFormValue({
            ...values,
            tlqn: total,
        });
    }, [start, fin, faltas, extra]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(
                `nominas/employe/nomina`,
                {
                    ...values,
                    tipo: 'FIN-AÑO',
                    id_emp,
                    dia,
                    agente: auth.uid,
                    inicio: start,
                    total: values.tlqn + values.tlnaldo + values.tlprima + values.tlvac,
                },
                'POST'
            );
            setResp(res);
            // callBk();
            reset();
            onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose} dialogClassName="modal-full-width">
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">Nomina de fin de año</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col sm="4">
                            <Form noValidate validated={validated} onSubmit={onSubmit}>
                                <Card>
                                    <Card.Header className="bg-secondary fw-bolder text-white">
                                        Datos de nomina fin de año {values.tlqn}
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            {/* <Col>
                                                <p>
                                                    <strong>Días de vacaciones tomados:</strong> {diasTomados}
                                                </p>
                                                <p>
                                                    <strong>Días de vaciones restantes:</strong> {diasPagados}
                                                </p>
                                                <p>
                                                    <strong>Prima vacacional recalculada:</strong> $
                                                    {primaVacacional.toFixed(2)}
                                                </p>
                                                <p>
                                                    <strong>Aguinaldo:</strong> ${finanio.aguinaldo.toFixed(2)}
                                                </p>
                                                <p>
                                                    <strong>Total final:</strong> ${totalFinal.toFixed(2)}
                                                </p>
                                                {JSON.stringify(values)}
                                            </Col> */}
                                            <Col>
                                                <Form.Group controlId="validationCustom004">
                                                    <Form.Label>Dias de vacaciones tomadas</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max={finanio.diasVacaciones}
                                                        value={diasTomados}
                                                        onChange={(e) => setDiasTomados(Number(e.target.value))}
                                                    />
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <Card>
                                    <Card.Header className="bg-secondary fw-bolder text-white">
                                        Datos de nomina
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom01">
                                                    <Form.Label>Periodo</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="date"
                                                        value={start}
                                                        name="start"
                                                        onChange={(e) => setStart(e.target.value)}
                                                    />

                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom01">
                                                    <Form.Label>al</Form.Label>

                                                    <Form.Control
                                                        required
                                                        type="date"
                                                        value={values.fin}
                                                        name="fin"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Row>{' '}
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom004">
                                                    <Form.Label>Faltas del mes</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.faltas}
                                                        name="faltas"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                            <Col xs lg="4">
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Dias no laborables</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.extra}
                                                        name="extra"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una cantidad
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>

                                            <Col xs lg="4">
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Pago en transferencia</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.transferencia}
                                                        name="transferencia"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una facha
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Form>
                        </Col>
                        <PrintFinYear data={{ ...values, dia, inicio: start }} user={user} onClose={funClose} />
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModFinYear;
